import StagesDashboard from './StagesDashboard';

export default StagesDashboard; 